export default "__VITE_PUBLIC_ASSET__7224568b__"